import { KYMW9101Component } from './kymw9101.component';

/**
 * ログ検索条件画面の値を管理するクラス
 *
 * @export KYMW9101Model
 * @class KYMW9101Model
 */
export class KYMW9101Model {

  kymw9101Component: KYMW9101Component;

  /* 商品マスタ：１、企画マスタ：２、指定しない：３ */
  public searchTableCondition: number;
  /* 受注コード */
  public orderCode: string = <string>'';
  /* いばらきコード */
  public coopIbarakiCode: string = <string>'';
  /* とちぎコード */
  public coopTochigiCode: string = <string>'';
  /* ぐんまコード */
  public coopGunmaCode: string = <string>'';
  /* ちばコード */
  public coopChibaCode: string = <string>'';
  /* さいたまコード */
  public coopSaitamaCode: string = <string>'';
  /* とうきょうコード */
  public coopTokyoCode: string = <string>'';
  /* ながのコード */
  public coopNaganoCode: string = <string>'';
  /* にいがたコード */
  public coopNiigataCode: string = <string>'';
  /* クルココード */
  public coopKurucoCode: string = <string>'';
  /* Pコード */
  public pcode: string = <string>'';
  /* アイテムコード */
  public itemCode: string = <string>'';
  /* ユーザーID */
  public userID: string = <string>'';
  /* 期間指定 */
  public selectDuration: boolean = <boolean>false;
  /* 更新日From */
  public updateDateFrom: string = <string>'';
  /* 更新日To */
  public updateDateTo: string = <string>'';

  public radioGroup: string = <string>'3';

  // チェックボックス
  public ibaraki: boolean = <boolean>false;
  public tochigi: boolean = <boolean>false;
  public gunma: boolean = <boolean>false;
  public chiba: boolean = <boolean>false;
  public saitama: boolean = <boolean>false;
  public tokyo: boolean = <boolean>false;
  public nagano: boolean = <boolean>false;
  public niigata: boolean = <boolean>false;
  public kuruco: boolean = <boolean>false;

  // 非活性用
  public orderCodeDisabled: boolean = <boolean>true;

}
